import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Text, Flex, useTheme } from '@vitvio/design-system';
import { Link, useLocation } from 'react-router-dom';
import { CoreClock } from '@vitvio/time-components';
import { ClockIcon } from '@vitvio/shared-components';
import { graphql, useLazyLoadQuery } from 'react-relay';
import type { ORConsoleHeaderQuery } from './__generated__/ORConsoleHeaderQuery.graphql';

const headerQuery = graphql`
  query ORConsoleHeaderQuery($id: ID!) {
    surgery(id: $id) {
      id
      name
      location {
        id
        name
      }
    }
  }
`;

export function ORConsoleHeader() {
  const { getColor, getRadius, getSpacing } = useTheme();
  const location = useLocation();
  const crumbs = location.pathname.split('/').filter(Boolean);

  const data = useLazyLoadQuery<ORConsoleHeaderQuery>(headerQuery, {
    id: crumbs[1],
  });

  return (
    <Flex justifyContent={'space-between'} flex={1}>
      <Breadcrumb my={'auto'} fontWeight={'semibold'} color={getColor('fg.muted')}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to={'/'}>
            Mission Control
          </BreadcrumbLink>
        </BreadcrumbItem>
        {crumbs.length > 1 && (
          <Breadcrumb>
            <BreadcrumbItem isCurrentPage>
              <Text>{`${data?.surgery?.name} (${data?.surgery?.location?.name})`}</Text>
            </BreadcrumbItem>
          </Breadcrumb>
        )}
      </Breadcrumb>
      <Flex bg={getColor('bg')} my={'auto'} mr={getSpacing('5')} borderRadius={getRadius('md')}>
        <ClockIcon
          boxSize="5"
          my={'auto'}
          ml={getSpacing('3')}
          fill={getColor('fg.muted')}
          outlineColor={getColor('border.accent')}
          color={getColor('fg')}
        />
        <CoreClock p="3" font="S_SemiBold" my="auto" />
      </Flex>
    </Flex>
  );
}
